import { Component, OnInit, ViewChild, Input} from '@angular/core';
import { MarketingMessagesOneColumnComponent } from '../marketing-messages-one-column/marketing-messages-one-column.component';
import { MarketingMessagesTwoColumnComponent } from '../marketing-messages-two-column/marketing-messages-two-column.component';
import { MarketingMessagesThreeColumnComponent } from '../marketing-messages-three-column/marketing-messages-three-column.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'pru-marketing-messages-slot-layout',
  templateUrl: './marketing-messages-slot-layout.component.html',
  styleUrls: ['./marketing-messages-slot-layout.component.scss']
})
export class MarketingMessagesSlotLayoutComponent implements OnInit {

  @ViewChild('marketingMessagesOneColumnComponent') marketingMessagesOneColumnComponent: MarketingMessagesOneColumnComponent;
  @ViewChild('marketingMessagesTwoColumnComponent') marketingMessagesTwoColumnComponent: MarketingMessagesTwoColumnComponent;
  @ViewChild('marketingMessagesThreeColumnComponent') marketingMessagesThreeColumnComponent: MarketingMessagesThreeColumnComponent;

  @Input() marketingSlotContent;
  @Input() marketingSlotTheme;
  @Input() contentId:string;
  @Input() retirementLink:string;
  style:SafeHtml;
  marketingColumnSize:number;
  htmlSlotStyle:string;
  innerHTML:string;

  constructor(private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getMarketingColumnSize(this.marketingSlotContent);
    this.getHTMLStylesFromJson(this.marketingSlotContent);
  }

  /*
    Used to get the number of columns for each marketing slot
  */ 
  getMarketingColumnSize(marketingContent):void {
    if( null!= marketingContent.columnWiseContent){
      this.marketingColumnSize = marketingContent.columnWiseContent.length;
    }
  }

  getHTMLStylesFromJson(marketingContent):void {
    this.htmlSlotStyle= marketingContent.htmlStyles;
    if(this.htmlSlotStyle!=""){
        var str1 = "<style>";
        var str2 = this.htmlSlotStyle; 
        var str3 = "</style>";
        this.innerHTML=str1.concat(str2).concat(str3);
        this.style =
          this._sanitizer.bypassSecurityTrustHtml(this.innerHTML);  
    }

  }

}
